<template>
  <label :class="[lablePosition === 'left' ? 'left': '', disabled ? 'disabled': '', 'custom-checkbox-wrap']">
    <span class="fake-label" v-if="checkboxLabel">{{ checkboxLabel }}</span>
    <div class="custom-checkbox">
      <input type="checkbox" :checked="isChecked" @change="toggleChecked" />
      <span :class="['checkmark', {'checked': isChecked}]">
        <i class="icon-tik" v-if="isChecked"></i>
      </span>
    </div>
  </label>
</template>
<script>
  export default {
	  name: 'Checkbox',
    props: {
      value: Boolean, // Use 'v-model' to bind the checkbox value
      disabled: {
        type: Boolean,
        default: false
      },
      checkboxLabel: {},
      lablePosition: String
    },
    computed: {
      isChecked() {
        return this.value;
      },
    },
    methods: {
      toggleChecked() {
        this.$emit('input', !this.isChecked);
      },
    },
  }
</script>
<style lang="scss">
.custom-checkbox-wrap {
  display: flex;
  align-items: center;
  gap: 10px;

  &.disabled {
    pointer-events: none;
    opacity: .7;
  }
  
  &.left {
    flex-direction: row-reverse;
  }

  .fake-label { user-select: none; }
}

.custom-checkbox {
  position: relative;
  display: inline-block;
  cursor: pointer;
  user-select: none;
  width: 20px;
  height: 20px;
  &.disabled {
    pointer-events: none;
    opacity: .7;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    background: var(--primary-bg);
    border: 0.5px solid var(--outline);
    display: flex;
    align-items: center;
    justify-content: center;
    &.checked {
      background-color: var(--accent);
      border: none;
    }
  }
}

.custom-checkbox .checkmark .icon-tik::before {
  color: #fff;
  font-size: 14px;
}

.custom-checkbox input:checked + .checkmark .icon-tik {
  display: block;
}

</style>
